var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstalaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 53.8332H54.4375M26.3333 53.8332V30.0483C26.3333 27.2886 26.3333 25.9095 26.8511 24.855C27.2991 23.9375 28.0256 23.1849 28.9268 22.7048C29.9433 22.1665 31.2733 22.1665 33.9333 22.1665H34.5667C37.2267 22.1665 38.5567 22.1665 39.5732 22.7048C40.4746 23.1853 41.2011 23.9384 41.6489 24.8566C42.1667 25.9095 42.1667 27.2886 42.1667 30.0483V53.8332M35.8333 28.4998H32.6667M35.8333 34.8332H32.6667M35.8333 41.1665H32.6667M51.35 53.8332V37.1195C51.35 33.4699 50.0865 32.1352 46.7188 32.1352H42.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstalaciones);
export default __webpack_public_path__ + "static/media/ic_instalaciones.a6818d4e5f738e31bc05d80d9e48686a.svg";
export { ForwardRef as ReactComponent };